import { useEffect, useState } from "react";
import styles from "./SelectStatus.module.scss";

type SelectProps = {
  options: Array<{ label: string; value: string }>;
  onSave: Function;
  status: string;
};

export const SelectStatus: React.FC<SelectProps> = ({
  options,
  onSave,
  status,
}) => {
  const [selection, setSelection] = useState<string>(options[0]?.value);

  useEffect(() => {
    setSelection(status);
  }, [status]);

  return (
    <div
      className={styles.wrapper}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <h4 className={styles.title}>Selecteer status</h4>
      <div className={styles.selectContainer}>
        {options.map(({ label, value }) => (
          <div className={styles.option}>
            <input
              type='radio'
              id={value}
              name='status'
              value={value}
              checked={selection === value}
              onChange={() => setSelection(value)}
            />
            <label htmlFor={value}>{label}</label>
          </div>
        ))}
        <button
          type='button'
          className={styles.button}
          onClick={() => onSave(selection)}
        >
          Opslaan
        </button>
      </div>
    </div>
  );
};
